/**
 * SubscriptionAccessoriesCtrl controller
 */

import { ACCESSORY_TYPES_FOR_FILTERS } from '../../app/core/constants'

/**
 * SubscriptionAccessoriesCtrl controller
 *
 * @class SubscriptionAccessoriesCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:SubscriptionAccessoriesCtrl
 */
/* @ngInject */

export function SubscriptionAccessoriesCtrl ($uibModal, Subscription, subscription) {
  const vm = this
  vm.accessoryTypes = ACCESSORY_TYPES_FOR_FILTERS

  /**
   * Subscription
   *
   * @memberof mwApp/packages.controller:SubscriptionAccessoriesCtrl
   * @type {models.Subscription}
   */
  vm.subscription = subscription

  /**
   * Delete Accessory
   *
   * @memberof mwApp/packages.controller:SubscriptionAccessoriesCtrl
   * @param id
   */
  vm.deleteAccessory = function (id) {
    vm.subscription.assignedAccessories = vm.subscription.assignedAccessories.filter(accessory => accessory.id !== id)
  }

  vm.makeMessageForDeletingAccessory = function (item) {
    const rules = vm.subscription._countDiscountRulesForSubscriptionProduct('ACCESSORY', item)
    return rules.length
  }
  vm.assignAccessory = function () {
    $uibModal.open({
      templateUrl: 'components/packages/views/addSubscriptionAccessories.html',
      controller: 'AddSubscriptionAccessoriesCtrl as vm',
      animation: false,
      size: 'xl',
      resolve: {
        accessories: function () {
          const assignedAccessoriesIds = vm.subscription?.assignedAccessories?.map(item => item.id) || []
          return subscription._getNetworkAccessoriesByCurrencyId(subscription.currency.id)
            .then(availableAccessories => availableAccessories.filter(item => !assignedAccessoriesIds.includes(item.id)))
        },
        subscription: function () {
          return vm.subscription
        }
      }
    }).result
      .then(
        function close (accessories) {
          vm.subscription.assignedAccessories = angular.copy(accessories)
        }
      )
  }
}
